import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { sendPageView } from "./analytics";

export default function PageViewTracker() {
    const location = useLocation();

    useEffect(() => {
        sendPageView(location);
    }, [location.pathname, location.search]);

    return null;
}
